<template>
  <div class="buyer-container">
    <div class="buyer-description">
      <h2>{{ $t('customerData') }}</h2>
      <p style="margin-top: 2.5rem">{{ $t('requiredFieldsDescription') }}</p>
    </div>
    <div class="form-container">
      <v-layout>
        <v-flex>
          <text-field
            v-model="buyer.firstName"
            :validator="vs.buyer.firstName"
            :error-messages="{
              required: $t('required'),
            }"
            :label="$t('firstName', 'First name')"
            class="pb-2"
          />
          <text-field
            v-model="buyer.lastName"
            :validator="vs.buyer.lastName"
            :error-messages="{
              required: $t('required'),
            }"
            :label="$t('lastName', 'Last name')"
            class="pb-2"
          />
          <text-field
            v-model="buyer.email"
            :validator="vs.buyer.email"
            :error-messages="{
              required: $t('required'),
              email: $t('EmailError'),
            }"
            :label="$t('email', 'E mail')"
            class="pb-2"
          />
          <text-field
            v-model="buyer.address"
            :validator="vs.buyer.address"
            :error-messages="{
              required: $t('required'),
            }"
            :label="$t('address', 'Address')"
            class="pb-2"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sport-organization-buyer-form',
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    buyer: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped>
.buyer-container {
  display: flex;
  flex-direction: column;
  padding: 32px 24px 40px 24px;
  gap: 2.5rem;
  border-top: 1px solid rgba(151, 151, 151, 0.5);
  border-bottom: 1px solid rgba(151, 151, 151, 0.5);
}
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-right: 0;
}
.buyer-description {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.address-container {
  display: flex;
  gap: 1.5rem;
}
h2 {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.8rem */
  letter-spacing: -0.045rem;
}
p {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
}
</style>
